import {useContext} from 'react'
import {CarouselCardContext} from '../context'

const useIsFirstCard = (): boolean => {
  const {cardIndex} = useContext(CarouselCardContext)

  return cardIndex === 0
}

export default useIsFirstCard
